import React, { useState } from "react";
import { Controller } from "react-hook-form";
import {
  Avatar,
  Box,
  Button,
  Button as MuiButton,
  Typography,
} from "@mui/material";
import { PhotoCamera } from "@mui/icons-material";
import { useSnackbar } from "../../../../component/common/Snackbar";

export default function ImageUpload({
  control,
  name,
  required,
  watch,
  setError,
  clearErrors,
  maxFileSize = 32 * 1024 * 1024, // Max file size of 32 MB
}) {
  const image = watch("image");
  // console.log("image = ", image);

  const [SnackbarComponent, showSnackbar] = useSnackbar();
  //   const handleImageChange = (event, onChange) => {
  //     const file = event.target.files?.[0] || null;
  //     if (file) {
  //       onChange(file); // pass File object to react-hook-form
  //     }
  //   };

  const handleImageChange = (event, onChange) => {
    const file = event.target.files?.[0] || null;

    if (!(file instanceof File) || !file.type.startsWith("image/")) {
      onChange(null);
      showSnackbar("Please upload a valid image file", "error");
      //   clearErrors(name); // 👈 clear required error
      //   setError(name, {
      //     type: "manual",
      //     message: "Please upload a valid image file",
      //   });
      event.target.value = ""; // reset so same file can be reselected
      return;
    }
    if (file instanceof File && file.size > maxFileSize) {
      onChange(null);
      // console.log("file = ", file);
      showSnackbar(
        `File is too big, max size ${maxFileSize / 1024 / 1024} MB.`,
        "warning"
      );
      event.target.value = ""; // reset so same file can be reselected
      return;
    }

    // ✅ Clear error if valid
    clearErrors(name);
    onChange(file);
    event.target.value = "";
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{ required: required ? "Image is required." : false }}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          // Decide what to show in Avatar
          let avatarSrc = "";
          if (image) {
            // If watchedImage is a File object, create temporary URL
            if (image instanceof File) {
              avatarSrc = URL.createObjectURL(image);
            } else if (typeof image === "string") {
              avatarSrc = image; // existing URL
            }
          } else if (value) {
            // fallback to value from Controller
            avatarSrc = typeof value === "string" ? value : "";
          }

          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <Avatar
                src={avatarSrc}
                alt="Doctor"
                sx={{
                  width: 140,
                  height: 140,
                  border: "2px solid #eee",
                  // borderRadius: 0,
                  mb: 1,
                  bgcolor: "secondary.main",
                }}
              />

              <label htmlFor="doctor-image-upload">
                <input
                  accept="image/*"
                  id="doctor-image-upload"
                  type="file"
                  style={{ display: "none" }}
                  onChange={(e) => handleImageChange(e, onChange)}
                />
                <Button
                  variant="outlined"
                  startIcon={<PhotoCamera fontSize="small" />}
                  component="span"
                  fullWidth
                >
                  Upload Photo
                </Button>
              </label>

              {error && (
                <Typography color="error" sx={{ fontSize: 12, mt: 0.6 }}>
                  {error.message}
                </Typography>
              )}
            </Box>
          );
        }}
      />
      <SnackbarComponent />
    </>
  );
}
